export default "__VITE_ASSET__c20e73cc__";